module.exports = __webpack_public_path__ + "assets/img/activity-time-0a81c1db.png";